import setOrderCustomFormImport from './setOrderCustomForm'
import setOrderCustomFormSortImport from './setOrderCustomFormSort'
import addOrderCustomFormFieldImport from './addOrderCustomFormField'
import setOrderCustomFormStatusImport from './setOrderCustomFormStatus'

export const setOrderCustomForm = setOrderCustomFormImport
export const setOrderCustomFormSort = setOrderCustomFormSortImport
export const addOrderCustomFormField = addOrderCustomFormFieldImport
export const setOrderCustomFormStatus = setOrderCustomFormStatusImport



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/mutations/index.js